import PropTypes from 'prop-types';

import { FormHelperTextStyled } from './TrlFormHelperText.styles';

export const TrlFormHelperText = ({ helperType, helperText, marginInline }) => {
  return (
    <FormHelperTextStyled helperType={helperType} marginInline={marginInline}>
      {helperText}
    </FormHelperTextStyled>
  );
};

TrlFormHelperText.propTypes = {
  helperType: PropTypes.oneOf([
    'warning',
    'error',
    'info',
    'inactive',
    'default',
  ]).isRequired,
  helperText: PropTypes.string.isRequired,
  marginInline: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};
